import script from "./TProfissional.vue?vue&type=script&lang=ts&setup=true"
export * from "./TProfissional.vue?vue&type=script&lang=ts&setup=true"

import "./TProfissional.vue?vue&type=style&index=0&id=b7339670&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7339670"]])

export default __exports__